module.exports = "/_next/static/images/68fa1c3b4503a264a1c0650283919efc-anticipate-lg.png.webp";